import React from "react";
import CardLayout from "components/foundation/templates/CardLayout";
import ReferenceField from "../Create/CreateDocumentForm/CreateDocumentFormField/ReferenceField";
import { ReferenceUserDto } from "apis/data-contracts";

const ReferenceUserEditModal = ({
  referenceUsers,
  onChangeReferenceUsers,
  author,
  approvedUser,
}: {
  referenceUsers?: ReferenceUserDto[];
  onChangeReferenceUsers: (referenceUsers: ReferenceUserDto[]) => void;
  author: string;
  approvedUser?: string;
}) => {
  return (
    <CardLayout.Container
      header={{
        title: "참조자 수정",
      }}
      gap={20}
      headerColor="#171D23"
      style={{
        borderRadius: "0",
        boxShadow: "none",
        padding: "0 0 2rem 0",
      }}
    >
      <ReferenceField
        defaultReferenceUsers={referenceUsers || []}
        onChangeReferenceUsers={onChangeReferenceUsers}
        isModal={true}
        author={author}
        decisionManager={approvedUser}
      />
    </CardLayout.Container>
  );
};

export default ReferenceUserEditModal;
